import { action, observable, makeObservable, computed } from 'mobx';

import type { AlertGroup } from '../../types/common.consts';

export class AlertsCounter {
	taskAlerts = new Set<string>();
	driverAlerts = new Set<string>();
	optimizationAlerts = new Set<string>();

	constructor() {
		makeObservable(this, {
			taskAlerts: observable,
			driverAlerts: observable,
			optimizationAlerts: observable,
			add: action,
			reset: action,
			allNewAlerts: computed
		});
	}

	add = (key: AlertGroup, alerts: string[]) => {
		alerts.forEach(id => this[key].add(id));
	};

	remove = (alertId: string) => {
		this.taskAlerts.delete(alertId);
		this.driverAlerts.delete(alertId);
		this.optimizationAlerts.delete(alertId);
	};

	reset = (key: AlertGroup) => {
		this[key].clear();
	};

	get allNewAlerts() {
		return new Set([...this.taskAlerts, ...this.driverAlerts, ...this.optimizationAlerts]);
	}
}
